/** Units (lessons) list cache; invalidate after bulk JSON import from the module page. */
export const lessonCache = {
  lessons: null,
  chapterId: null,
  page: 1,
  totalPages: 1,
  totalCount: 0,
  firstLoad: true,
  lastSearch: undefined,
};

export function invalidateLessonCache() {
  lessonCache.lessons = null;
  lessonCache.chapterId = null;
  lessonCache.page = 1;
  lessonCache.totalPages = 1;
  lessonCache.totalCount = 0;
  lessonCache.firstLoad = true;
  lessonCache.lastSearch = undefined;
}

function coerceNumber(value) {
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
}

/**
 * Optimistically bump "unit -> lessons count" in the cached units list.
 * Used so the Units page updates immediately after adding/deleting lesson-content.
 */
export function bumpUnitLessonsCount(unitId, delta = 1) {
  if (!unitId || !Array.isArray(lessonCache.lessons)) return;

  const targetId = String(unitId);

  lessonCache.lessons = lessonCache.lessons.map((unit) => {
    const id = unit?.id ?? unit?._id ?? unit?.lesson_id;
    if (id == null || String(id) !== targetId) return unit;

    const current =
      coerceNumber(unit?.lessons_count) ??
      coerceNumber(unit?.lesson_count) ??
      coerceNumber(unit?.children_count) ??
      coerceNumber(unit?.child_count) ??
      (Array.isArray(unit?.lessons) ? unit.lessons.length : null) ??
      (Array.isArray(unit?.children) ? unit.children.length : null) ??
      0;

    const next = Math.max(0, current + Number(delta || 0));

    return {
      ...unit,
      lessons_count: next,
      lesson_count: next,
      children_count: next,
      child_count: next,
    };
  });
}
